import CourseListPage from "./CourseListPage";

export default function AdminCourses() {
  return (
    <CourseListPage
      kind="final"
      pageTitle="Cursos"
      pageSubtitle="Crea cursos con uno o varios temas, impórtalos desde JSON, y asígnalos a usuarios."
      newItemLabel="Nuevo curso"
      newItemPath="/admin/courses/new"
      editPathFor={(id) => `/admin/courses/${id}/edit`}
      importLabel="Importar curso (JSON)"
      showTemasColumn
      temasNoun="Temas"
      deleteConfirmLabel="¿Eliminar este curso? Se eliminarán intentos y asignaciones."
      emptyRowTestId="no-courses"
    />
  );
}
